export function ViewDetails({ url }) {
  return (
    <a
      className={`property-card__more button button_size_small`}
      href={url}
      target={`_blank`}
    >
      View details
    </a>
  );
}
